import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*
SPDX-FileCopyrightText: 2024 Genome Research Ltd.

SPDX-License-Identifier: MIT
*/
import { useEffect, useState } from "react";
import { Avatar } from "rsuite";
import { convertToPath } from "../general/utils";
import { Nav, NavDropdown } from "react-bootstrap";
function ProfileDropdown(props) {
    const { user, pages, onLogout } = props;
    const [userName, setUserName] = useState("");
    const [photoUrl, setPhotoUrl] = useState(null);
    const [loading, setLoading] = useState(true);
    // Displaying user's initials
    const getInitials = (name) => {
        const nameParts = name.split(" ");
        return nameParts.length >= 2
            ? `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase()
            : name.substring(0, 2)?.toUpperCase() || "";
    };
    const fetchOrcidProfile = async (orcidId) => {
        try {
            const response = await fetch(`https://pub.orcid.org/v3.0/${orcidId}`, {
                headers: { Accept: "application/json" },
            });
            const data = await response.json();
            const fullName = `${data.person.name["given-names"].value} ${data.person.name["family-name"].value}`;
            const photoUrl = data.person["photo"]?.url || null;
            setUserName(fullName);
            setPhotoUrl(photoUrl);
            sessionStorage.setItem("userName", fullName);
            sessionStorage.setItem("photoUrl", photoUrl || "");
        }
        catch (error) {
            console.error("Error fetching ORCID profile:", error);
            const storedName = sessionStorage.getItem("userName");
            const storedPhotoUrl = sessionStorage.getItem("photoUrl");
            setUserName(storedName || user.name || "");
            setPhotoUrl(storedPhotoUrl || null);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        const storedName = sessionStorage.getItem("userName");
        const storedPhotoUrl = sessionStorage.getItem("photoUrl");
        if (storedName && storedPhotoUrl !== null) {
            setUserName(storedName);
            setPhotoUrl(storedPhotoUrl || null);
            setLoading(false);
        }
        else {
            if (user?.oidc_id) {
                if (user.oidc_id.includes("/") || (user.oidc_id.includes("-") && user.oidc_id.length === 19)) {
                    const orcidId = user.oidc_id.split("/").pop();
                    fetchOrcidProfile(orcidId);
                }
                else {
                    setUserName(user.oidc_id.split("@").shift() || "");
                }
            }
            else {
                setUserName(user.name || "");
                setPhotoUrl(null);
                setLoading(false);
            }
        }
    }, [user]);
    const avatarContent = loading ? (_jsx("div", { className: "initials-avatar", children: getInitials(userName) })) : photoUrl ? (_jsx("img", { src: photoUrl, alt: "Profile", className: "profile-photo" })) : (_jsx("div", { className: "initials-avatar", children: getInitials(userName) }));
    const dropdownPages = pages?.map((page) => {
        const link = convertToPath(page.name);
        return (_jsx(Nav.Link, { href: link, children: page.name }, page.name));
    });
    const dropdownContents = (_jsxs("div", { className: "nav-dropdown-box", children: [dropdownPages, _jsx(Nav.Link, { className: "logout", onClick: () => {
                    sessionStorage.removeItem("userName");
                    sessionStorage.removeItem("photoUrl");
                    onLogout();
                }, children: "Logout" }, "logout")] }));
    return (_jsxs(NavDropdown, { className: "profile-dropdown", title: _jsx(Avatar, { size: "sm", circle: true, children: avatarContent }), placement: "bottom-end", children: [userName && (_jsxs("div", { className: "profile-container", children: [_jsx("p", { children: "Signed in as" }), _jsx("div", { className: "profile-details", children: _jsx("p", { className: "user-name", children: userName }) })] })), dropdownContents] }));
}
export default ProfileDropdown;
